import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWarehouse } from "src/models/Stores/Warehouse.models";

interface WarehouseState {
  warehouses: IWarehouse[];
  warehouseToEdit: IWarehouse | null;
}

const initialState: WarehouseState = {
  warehouses: [],
  warehouseToEdit: null,
};

const WarehouseSlice = createSlice({
  name: "Warehouse",
  initialState,
  reducers: {
    setWarehouseList: (state, action: PayloadAction<IWarehouse[]>) => {
      state.warehouses = action.payload;
    },
    concatListWarehouse: (
      state: WarehouseState,
      action: PayloadAction<IWarehouse[]>
    ) => {
      state.warehouses = [...state.warehouses.concat(action.payload)];
    },
    setWarehouseToEdit: (state, action: PayloadAction<IWarehouse | null>) => {
      state.warehouseToEdit = action.payload;
    },
    addWarehouse: (state, action: PayloadAction<IWarehouse>) => {
      state.warehouses.push(action.payload);
    },
    addWarehouses: (state, action: PayloadAction<IWarehouse[]>) => {
      state.warehouses.push(...action.payload);
    },
    updateWarehouse: (state, action: PayloadAction<IWarehouse>) => {
      let itemIndex = state.warehouses.findIndex(
        item => item.warehouseId === action.payload.warehouseId
      );
      if (itemIndex !== -1) state.warehouses[itemIndex] = action.payload;
    },
    deleteWarehouse: (state, action: PayloadAction<number>) => {
      const newArray = state.warehouses.filter(
        item => item.warehouseId !== action.payload
      );
      state.warehouses = newArray;
    },
  },
});

export const {
  setWarehouseList,
  concatListWarehouse,
  setWarehouseToEdit,
  addWarehouse,
  addWarehouses,
  updateWarehouse,
  deleteWarehouse,
} = WarehouseSlice.actions;

export default WarehouseSlice.reducer;
